import React from 'react';
import {
  AppBar,
  AppBarProps,
  Toolbar,
  ToolbarProps,
  Box,
  BoxProps,
  IconButtonProps,
} from '@mui/material';
// COMPONENTS
import DrawerButton from './DrawerButton';
import SubTopicDrawerButton from './SubTopicDrawerButton';
import BackButton from './BackButton';
import { whiteButtonStyles } from '../../Button/styles';
// HELPERS
import { SafeAreaGaps, isMobileScreen } from '../../../helper/Mobile';

type TLeftContentTypes = 'drawer' | 'backButton' | 'subtopic-nav-bar';

export interface ILeftContents {
  type: TLeftContentTypes;
  isVisible?: boolean;
  contentContainerStyle?: BoxProps;
  iconButtonProps?: IconButtonProps;
}
export interface IMobileHeader {
  transparent?: boolean;
  appBarProps?: AppBarProps;
  toolBarProps?: ToolbarProps;
  leftContents?: ILeftContents;
}

export const headerHeight = '56px';

const defaultAppBarStyles: AppBarProps['sx'] = {
  backgroundColor: 'background.default',
  minHeight: headerHeight,
  paddingTop: SafeAreaGaps.top,
  paddingLeft: SafeAreaGaps.left,
  paddingRight: SafeAreaGaps.right,
  display: isMobileScreen()
    ? 'flex'
    : {
        xs: 'flex',
        sm: 'none',
      },
};
const defaultToolBarStyles: React.CSSProperties = {
  paddingLeft: '10px',
  paddingRight: '10px',
};
const EmptyContent = () => {
  return (
    <div style={{ flexGrow: 1 }}>
      <div style={{ minWidth: '32px', minHeight: '32px' }} />
    </div>
  );
};

const MobileHeader: React.FC<IMobileHeader> = ({
  transparent = true,
  appBarProps,
  toolBarProps,
  leftContents,
}) => {
  // STYLES
  let defaultAppBarElevation: AppBarProps['elevation'] = 1;
  if (transparent === true) {
    defaultAppBarStyles.backgroundColor = 'transparent';
    defaultAppBarElevation = 0;
  }

  // RENDER
  const LeftContents = () => {
    if (leftContents) {
      const {
        isVisible,
        type,
        contentContainerStyle,
        iconButtonProps,
      } = leftContents;
      if (isVisible !== false) {
        if (type === 'drawer') {
          return (
            <Box sx={{ flexGrow: 1, ...contentContainerStyle }}>
              <DrawerButton
                {...iconButtonProps}
                sx={
                  iconButtonProps && iconButtonProps.sx
                    ? iconButtonProps.sx
                    : whiteButtonStyles
                }
              />
            </Box>
          );
        }
        if (type === 'backButton') {
          return (
            <Box sx={{ flexGrow: 1, ...contentContainerStyle }}>
              <BackButton
                {...iconButtonProps}
                sx={
                  iconButtonProps && iconButtonProps.sx
                    ? iconButtonProps.sx
                    : whiteButtonStyles
                }
              />
            </Box>
          );
        }
        if (type === 'subtopic-nav-bar') {
          return (
            <SubTopicDrawerButton
              {...iconButtonProps}
              sx={
                iconButtonProps && iconButtonProps.sx
                  ? iconButtonProps.sx
                  : whiteButtonStyles
              }
            />
          );
        }
      }
    }
    return <EmptyContent />;
  };

  return (
    <AppBar
      elevation={
        appBarProps && appBarProps.elevation
          ? appBarProps.elevation
          : defaultAppBarElevation
      }
      position={
        appBarProps && appBarProps.position ? appBarProps.position : 'fixed'
      }
      sx={
        appBarProps && appBarProps.style
          ? { ...defaultAppBarStyles, ...appBarProps.style }
          : defaultAppBarStyles
      }
    >
      <Toolbar
        style={
          toolBarProps && toolBarProps.style
            ? {
                ...defaultToolBarStyles,
                ...toolBarProps.style,
              }
            : defaultToolBarStyles
        }
      >
        <LeftContents />
      </Toolbar>
    </AppBar>
  );
};

export default MobileHeader;
